module.exports = __webpack_public_path__ + "static/img/step_two.569cc8e4.png";